module.exports = __webpack_public_path__ + "img/photo-lieu-448-3.298f99bb.jpeg";